module.exports = __webpack_public_path__ + "glyphicons-filetypes-regular.89371af4b70c3663122e.svg";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.filetypes.pro/glyphicons-filetypes-regular.svg
// module id = ../../../../../src/assets/css/fonts/glyphicons.filetypes.pro/glyphicons-filetypes-regular.svg
// module chunks = 2